/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import './styles.scss';

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 50,
    height: 24,
    padding: 0,
    display: 'flex',
    overflow: 'visible',
    alignItems: 'center',
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(26px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#4dccc5',
        borderColor: theme.palette.primary.main,
      },
    },
  },
  disabled: {
    '&$checked': {
      color: '#bdbdbd',
    },
    '& + $track': {
      opacity: `${0.12}!important`,
      backgroundColor: '#000!important',
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 16,
    opacity: 1,
    backgroundColor: '#6E7180',
  },
  checked: {},
}))(Switch);

const Switches = ({ isOn, onChange, disabled }) => (
  <AntSwitch checked={isOn} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
);
Switches.propTypes = {
  isOn: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
Switches.defaultProps = {
  onChange: () => {},
  isOn: false,
  disabled: false,
};

export default Switches;
